import { Vector2 } from "../math/vector2";
import { BallTypeEnum } from "../types/ball-type-enum";
import { GameConfig } from "../config/game-config";
import { IVector2 } from "../types/game-config-type";
import { Ball } from "./ball";

export class BallsFactory {

    public static createPool8Balls(): Ball[] {

        let gameBalls: Ball[];
      
        // solid balls from 1 to 7
        const solidBalls: Ball[] = GameConfig.redBallsPositions.map(
        (position: IVector2, i: number) =>
            new Ball(Vector2.copy(position as Vector2), BallTypeEnum.Solid, i + 1)
        );

        // stripe balls form 9 to 15
        const stripeBalls: Ball[] = GameConfig.yellowBallsPositions.map(
        (position: IVector2, i: number) =>
            new Ball(Vector2.copy(position as Vector2), BallTypeEnum.Stripe, i + 9)
        );

        gameBalls = [new Ball(Vector2.copy(GameConfig.cueBallPosition), BallTypeEnum.Cue, 0),
            ...solidBalls,
            new Ball(Vector2.copy(GameConfig.eightBallPosition), BallTypeEnum.Eight, 8),
            ...stripeBalls];
        
        return gameBalls;
    }

    public static createPool8UKBalls(): Ball[] {

        let gameBalls: Ball[];

        // solid balls from 1 to 7
        const solidBalls: Ball[] = GameConfig.redBallsPositions.map(
        (position: IVector2, i: number) =>
            new Ball(Vector2.copy(position as Vector2), BallTypeEnum.Solid, 3)
        );

        // stripe balls form 9 to 15
        const stripeBalls: Ball[] = GameConfig.yellowBallsPositions.map(
        (position: IVector2, i: number) =>
            new Ball(Vector2.copy(position as Vector2), BallTypeEnum.Stripe, 1)
        );

        gameBalls = [new Ball(Vector2.copy(GameConfig.cueBallPosition), BallTypeEnum.Cue, 0),
            ...solidBalls,
            new Ball(Vector2.copy(GameConfig.eightBallPosition), BallTypeEnum.Eight, 8),
            ...stripeBalls];

        return gameBalls;
    }

    public static createPool9Balls(): Ball[] {

        let gameBalls: Ball[];

        // solid balls from 1 to 8
        const solidBalls: Ball[] = GameConfig.nineBallsPositions.map(
            (position: IVector2, i: number) =>
            new Ball(Vector2.copy(position as Vector2), BallTypeEnum.Solid, i + 1)
        );

        gameBalls = [new Ball(Vector2.copy(GameConfig.cueBallPosition), BallTypeEnum.Cue, 0),
            ...solidBalls,
            new Ball(Vector2.copy(GameConfig.nineBallPosition), BallTypeEnum.Stripe, 9)
        ];

        return gameBalls;
    }

    public static createSnookerBalls(isSixRed: boolean): Ball[] {
    
        let gameBalls: Ball[];
        let redBalls: Ball[];
        let redBallNumber: number = 3;
        
        // red balls
        if (isSixRed) {
            redBalls = GameConfig.snookerSixRedBallsPositions.map(
            (position: IVector2, i: number) =>
                new Ball(Vector2.copy(position as Vector2), BallTypeEnum.Solid, redBallNumber)
            );    
        } else {
            redBalls = GameConfig.snookerRedBallsPositions.map(
            (position: IVector2, i: number) =>
                new Ball(Vector2.copy(position as Vector2), BallTypeEnum.Solid, redBallNumber)
            );    
        }

        gameBalls = [
            new Ball(Vector2.copy(GameConfig.cueBallPosition), BallTypeEnum.Cue, 0),
            ...redBalls,
            new Ball(Vector2.copy(GameConfig.yellowBallPosition), BallTypeEnum.Color, 1),
            new Ball(Vector2.copy(GameConfig.brownBallPosition), BallTypeEnum.Color, 7),
            new Ball(Vector2.copy(GameConfig.greenBallPosition), BallTypeEnum.Color, 6), 
            new Ball(Vector2.copy(GameConfig.blueBallPosition), BallTypeEnum.Color, 2),
            new Ball(Vector2.copy(GameConfig.pinkBallPosition), BallTypeEnum.Color, 4),
            new Ball(Vector2.copy(GameConfig.blackBallPosition), BallTypeEnum.Color, 8),
        ];

        return gameBalls;
    }
}